import React from 'react'

import Box from 'components_new/atoms/Box'
import MenuItem from 'components_new/atoms/Menu/MenuItem'
import TextField from 'components_new/atoms/TextField'

import { useTranslation } from 'language/translator'
import { TSliceFilterCondition } from 'types/GlobalSlice'

import { conditionOptions, DEFAULT_CONDITIONS } from './lib'
import { translateFilterCondition } from 'utils/enumTranslator'

interface ConditionProps {
  conditions?: TSliceFilterCondition[]
  disabled?: boolean
  onChange: (condition: TSliceFilterCondition) => void
  selected: TSliceFilterCondition
}

const ConditionSelect = (props: ConditionProps) => {
  const {
    conditions = DEFAULT_CONDITIONS,
    disabled,
    onChange,
    selected
  } = props

  const { translateEnum } = useTranslation()

  const options = conditions.map((condition) => ({
    ...conditionOptions[condition],
    body: translateEnum('conditions', condition)
  }))

  return (
    <TextField
      disabled={disabled}
      onChange={(event) => {
        const value = options.find((option) => option.id === event.target.value)

        if (value) {
          onChange(value.id)
        }
      }}
      select={true}
      SelectProps={{
        hideIcon: true,
        renderValue: (value: string | null) => {
          const selected = options.find((option) => option.id === value)

          return <>{selected?.title}</>
        }
      }}
      size={'small'}
      sx={{
        maxWidth: '100%',
        minWidth: 0,
        mb: 1,
        flexShrink: 0,
        width: 40,
        '& .MuiInputBase-input': {
          display: 'flex',
          justifyContent: 'center',
          paddingRight: '12px!important',
          bgcolor: `${translateFilterCondition[selected].color}.background`
        },
        '&:focus': {
          bgcolor: `${translateFilterCondition[selected].color}.background`
        }
      }}
      value={selected}
    >
      {options.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          <Box component="span" sx={{ color: 'text.primary' }}>
            {option.title}
          </Box>
          <Box component="span" sx={{ color: 'text.disabled', ml: '0.5em' }}>
            {option.body}
          </Box>
        </MenuItem>
      ))}
    </TextField>
  )
}

export default ConditionSelect
